export default __webpack_public_path__ + "static/media/initiatives.e1cfca58.svg";